import Lastfall from './Lastfall'

export default class Knotenlast{
    /**
     * Klasse für Knotenlasten
     * 
     * @param {Knotenlastliste} list Liste aller Knotenlasten eines Lastfalls
     * @param {number} fX Wert der Last in X-Richtung
     * @param {number} fY Wert der Last in Y-Richtung
     * @param {number} M  Wert eines Momentes (rechtsdrehend positiv)
     * @param {Knotenliste} Knotenliste Liste der Knoten an denen die Last wirkt
     * @param {Lastfall} Lastfall zugehöriger Lastfall in dem die Knotenlast gespeichert wird
     */
    constructor(list, fX, fY, M, Knotenliste, Lastfall){
        this.Werte = [fX, fY, M]
        this.Lastfall = Lastfall || undefined
        this.Knotenliste = Knotenliste ? [...Knotenliste] : []
        this.list = list || null
        this.d3Node = undefined
    }

    set fX(v){ this.Werte[0] = v }
    set fY(v){ this.Werte[1] = v }
    set M(v) { this.Werte[2] = v }
    get fX() { return this.Werte[0] }
    get fY() { return this.Werte[1] }
    get M() { return this.Werte[2] }
    get FRes() { return Math.sqrt(this.Werte[0]*this.Werte[0]+this.Werte[1]*this.Werte[1])}
    get number() {
        if(this.list) return this.list.indexOf(this)+1
        else return null
    }
    get name() { return 'Knotenlast Nr. ' + this.number }
    release_bindings(){ 
        this.Knotenliste.splice(0, this.Knotenliste.length)
        return this.Lastfall.deleteKnotenlast(this)
    }
    add_Knotenverknüpfung(knoten){this.Knotenliste.push(knoten)}
    delete_Knotenverknüpfung(knoten){
        if (this.Knotenliste.indexOf(knoten) == -1) return console.log('Knoten nicht in Liste')
        this.Knotenliste.splice(this.Knotenliste.indexOf(knoten),1)
        if (this.Knotenliste.length == 0) return this.Lastfall.deleteKnotenlast(this)
    }

}
